import axiosInstance from "../axiosInstance";

export const catalogTypeService = {
  fetch: async (limit = 100, skip = 0, searchValue) => {
    try {
      let query = `/catalog-type?$limit=${limit}&$skip=${skip}&$sort[name]=1`;
      if (searchValue) query += `&name[$search]=${searchValue}`;
      const response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
